import { Navigate, useLocation } from 'react-router-dom';
import { legacyGamesDestination } from '../utils/legacyRoutes';

export const LegacyGamesRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={legacyGamesDestination(search)} replace />;
};